import { useQuery } from "@tanstack/react-query";
import { DEFAULT_STALE_TIME } from "neetocommons/constants";

import auditLogsApi from "./api";
import { PERMISSIONS_LIST_QUERY_KEY } from "./constants";

export const useFetchPermissions = () =>
  useQuery({
    queryKey: [PERMISSIONS_LIST_QUERY_KEY],
    queryFn: auditLogsApi.fetchPermissions,
    staleTime: DEFAULT_STALE_TIME,
  });
